<template>
    <common-modal :width="'medium'" @emitEvent="emitEvent($event, ['close'])" @close="emitEvent({ name: 'close' })">
        <common-content-spacer height="huge">
            <common-page-header
                :heading="
                    $t('pages.auth.signup.steps.register_physicians.modals.register_physicians_modal.heading', {
                        practiceName: $auth.getPractice().name,
                    })
                "
                :isCenter="true"
            ></common-page-header>

            <ul class="physician-profile-modal--list">
                <li v-for="physician in physicians" :key="physician.id">
                    <div class="physician-profile-modal--container">
                        <div class="physician-profile-modal--user-profile">
                            <common-user-avatar :user="physician" :isCurrent="false" size="user-menu"></common-user-avatar>

                            <div class="physician-profile-modal--user-name">
                                <common-user-name
                                    class="physician-profile-modal--user-profile-name"
                                    :user="physician"
                                ></common-user-name>

                                <p class="physician-profile-modal--user-profile-specialty">
                                    {{ physician.specialities[0].speciality.name }}
                                </p>
                            </div>
                        </div>

                        <template v-if="!physician.isProfileComplete">
                            <common-button
                                :label="
                                    $t(
                                        'pages.auth.signup.steps.register_physicians.modals.register_physicians_modal.complete_profile',
                                    )
                                "
                                size="small-font"
                                type="secondary"
                                @click="completeProfile(physician)"
                            ></common-button>
                        </template>
                    </div>
                </li>
            </ul>

            <common-buttons>
                <common-button
                    :label="$t('pages.auth.signup.steps.register_physicians.modals.register_physicians_modal.close')"
                    type="primary"
                    @click="emitEvent({ name: 'close' })"
                ></common-button>
            </common-buttons>
        </common-content-spacer>
    </common-modal>
</template>

<script>
    export default {
        props: {
            physicians: { type: Array, required: true },
        },

        methods: {
            completeProfile(physician) {
                this.$auth.setActiveMember(physician)
                this.$router.go()
            },
        },
    }
</script>
